import React, { useState } from 'react';
import { EditorLink } from './EditorLink';
import './EditorLinks.less';
import { ActionLinkModel } from './PropertyGrid';
import './EditorLinks.less';
import { includeLinkInPropertyGrid } from './utils/PropertyGridUtils';
import { ActionDisplayType } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions';
import {
  FlowStepEditorInformation,
  isFlowStepMappingEditorInformation,
  FlowStepMappingEditorInformation,
} from '@decisions/server/DecisionsFramework/Design/Flow';
import { MappingEditorDialog } from 'domains/designers/FlowDesigner/MappingEditor/MappingEditorDialog';

export interface EditorLinkModel {
  info: FlowStepEditorInformation;
  action: (e: any) => any;
}

interface IEditorLinksProps extends React.HTMLProps<{}> {
  links: EditorLinkModel[];
  actions?: ActionLinkModel[];
  suspendParentUpdates?: () => void;
  resumeParentUpdates?: () => Promise<void>;
}

/**
 * Editor Links above Property Grid in some places.
 *
 * FIXME seems these are Flow Designer specific, and not generic to Property Grid, and should be moved.
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function EditorLinks({ links, actions = [], suspendParentUpdates, resumeParentUpdates }: IEditorLinksProps) {
  const showActions = !!actions?.length;
  const showLinks = !!links?.length;
  const primaryActions = actions.filter(action => action.info.DisplayType === ActionDisplayType.Primary);
  actions = actions.filter(action => action.info.DisplayType !== ActionDisplayType.Primary);

  const [dialogInfo, setDialogInfo] = useState<FlowStepEditorInformation | null>(null);
  const onCloseDialog = async () => {
    // if we wait until resume is done, hopefully what's behind the dialog (Property Grid) will be done updating
    await resumeParentUpdates?.();
    setDialogInfo(null);
  };

  return showLinks || showActions ? (
    <>
      <section className="dpc-editor-links">
        {primaryActions.map(action => (
          <EditorLink key={action.info.Name} link={action} />
        ))}
        {showLinks &&
          links
            .filter(link => includeLinkInPropertyGrid(link.info))
            .map(link => {
              // override these actions to avoid reaching back into web.core to render Mapping Editor
              // can migrate this to react flow designer when it exists.
              link.action = isFlowStepMappingEditorInformation(link.info)
                ? () => {
                    suspendParentUpdates?.();
                    setDialogInfo(link.info);
                  }
                : link.action;
              return <EditorLink key={link.info.Name} link={link} />;
            })}
        {actions && actions.map(link => <EditorLink key={link.info.Name} link={link} />)}
      </section>
      {/* TODO This stuff should be in Flow Designer code, whenever we move it to React */}
      {/* For now it is here to avoid going back and forth with web.core */}
      {dialogInfo && isFlowStepMappingEditorInformation(dialogInfo) && (
        <MappingEditorDialog editorInfo={dialogInfo as FlowStepMappingEditorInformation} onClose={onCloseDialog} />
      )}
    </>
  ) : null;
}
